import React, { useContext } from "react";
import styles from "./CoverAbout.module.scss";
import PathContext from "../../context/path";
const CoverAbout = () => {
  const path = useContext(PathContext);
  return (
    <>
      <div className={styles.wrap}>
        <div className={styles.inner}>
          <h1 className={styles.title}>Р-Фарм — международная фармацевтическая компания полного цикла</h1>
          <div className={styles.text}>
            <p>Разрабатываем, выпускаем и поставляем препараты для профилактики, диагностики и лечения 50+ заболеваний. А также оснащаем медицинские учреждения высокотехнологичным оборудованием.</p>
          </div>
        </div>
        <div className={styles.figure}>
          <picture>
            <source media="screen and (max-width: 767px)" srcSet={`${path}/img/about-svg-mobile.svg`} />
            <img src={`${path}/img/about-svg.svg`} alt="" />
          </picture>
        </div>
      </div>
    </>
  );

}

export default CoverAbout;
